export default "__VITE_ASSET__BSXm1y4u__"